module.exports = __webpack_public_path__ + "static/media/pizza.e1647f79.svg";